import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page22() {
  useEffect(() => {
    document.title = "Маяк — Страница 21"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page20" />
        <ForwardLink href="/page22" />
      </div>

      <p style={{ textAlign: "right" }}>21.</p>
      <p>
        СТАРИК выдыхает. Немного успокаивается. Он понимает, как странно<br/>
        это было.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Не обращай внимания, парень. Ничего. Приготовь нам<br/>
        немного кофе. Впереди долгая ночь.<br/>
        Капелька кофе пойдет нам на пользу.
      </p>
      <p>СТАРИКУ не надо говорить, что он пьян.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p>
        МОЛОДОЙ снова смотрит на СТАРИКА: он потрясен. Испуган. Жалкая тень<br/>
        самого себя. Страшнее, чем его вспышка гнева.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – НОЧЬ</p>
      <p>
        МОЛОДОЙ лежит в кровати, курит сигарету. Читает руководство.<br/>
        Не может устроиться поудобнее. Беспокоится. Он держит ВЫРЕЗАННУЮ РУСАЛКУ<br/>
        в руке, рефлекторно потирая ее во всех запретных местах.
      </p>
      <p>ЧАСЫ монотонно тикают.</p>
      <p>Задержка.</p>
      <p>
        НЕ В ФОКУСЕ НА ЗАДНЕМ ПЛАНЕ: ЧАЙКА приземляется<br/>
        на окно.
      </p>
      <p>Пауза.</p>
      <p>ЧАЙКА начинает стучать в окно.</p>
      <p>Тук. Тук.</p>
      <p>МОЛОДОЙ слышит это.</p>
      <p>Тук.</p>
      <p>Как только он поворачивается к ней лицом... ЧАЙКА улетает.</p>
      <p>МОЛОДОЙ чувствует себя неловко. Он садится.</p>
      <p>
        Назад к кровати: ВЫРЕЗАННАЯ РУСАЛКА лежит на его<br/>
        простынях. Ждет его.
      </p>
      <br/>
      <p>ВНУТРИ. САРАЙ – НОЧЬ</p>
      <p>
        Голова МОЛОДОГО двигается вверх и вниз, слегка трясясь. Он<br/>
        прячется в тени сарая. Слышен шорох<br/>
        ткани и звяканье пряжки ремня. КАМЕРА ОПУСКАЕТСЯ<br/>
        ВНИЗ...
      </p>
      <p style={{ textAlign: "right" }}>21.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page20" />
        <ForwardLink href="/page22" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710013259/the-lighthouse-script/iq9qvrweoxnqnh6mz6i7.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page22;
